<template>
  <div id="History" class="package-wrapper">
    <div class="add-query">
    <h2>Your Packages</h2>
    <b-container fluid class="package-container">
        <b-row>
          <b-col lg="12" v-for="student_package in packages" :key="student_package.id">
            <div class="package-item">
              <h3 class="package-head">{{student_package.package_name}}</h3>
              <b-row>
                <b-col lg="12">
                  <b>Doubts:</b> <span>{{student_package.credits}}</span>
                </b-col>
                <b-col lg="12">
                  <b>Cost:</b> <span>{{student_package.cost}}/-</span>
                </b-col>
              </b-row>
              
            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
  </div>
</template>

<script>
export default {
  name: 'History',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      loader:true
    }
  },
  computed: {
    packages: function() {
      return this.$store.getters.get_user_packages;
    }
  },
  mounted: async function() {
    this.loader = true;
    var action = await this.$store.dispatch('fetch_user_packages');
    this.loader = false;
  },
  methods: {
    onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add-query h2 {
  color:#262e3b;
  text-transform: uppercase;
  font-weight: bold;
  padding:20px 0;
  border-bottom:1px solid #e5e5e5;
  width:90%;
  margin:0 auto;
}
.package-container {
  width:90%;
  margin:50px auto 0;
}
.package-item {
  margin: 10px;
}
.package-head {
  border-bottom:1px solid #efefef;
  color:#AACF37;
  font-weight:bold;
}
.package-item a {
  border-radius:10px;
}
.package-item p {
  margin:0;
}
.package-item .row,.package-item a {
  margin-top:20px;
  margin-bottom:20px;
}
.package-container .col-lg-4 {
  margin-bottom:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/PackagesHistory.vue